import { Box, TextField, Typography } from "@mui/material";

import { makeStyles } from "@mui/styles";
import clsx from "clsx";

const useStyles = makeStyles(() => ({
  root: {
    display: "flex",
    flexDirection: "column",
    width: "100%",
    marginTop: 12,
  },
  label: {
    color: "#949494",
    marginBottom: 3,
  },
  labelError: {
    color: "#f44335",
  },
  customTextField: {
    color: "#949494",

    "& .MuiOutlinedInput-root": {
      height: "100%",
    },
  },
  singleLine: {
    height: 35,
  },
}));

const CustomTextBox = ({
  label,
  onChange,
  value,
  error,
  InputProps,
  rows,
  inputRef,
  onKeyDown,
}) => {
  const classes = useStyles();

  return (
    <Box className={classes.root}>
      <Typography
        variant={"h6"}
        className={clsx({
          [classes.label]: true,
          [classes.labelError]: error,
        })}
      >
        {label}
      </Typography>
      <TextField
        variant="outlined"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        className={clsx({
          [classes.customTextField]: true,
          [classes.singleLine]: !rows,
        })}
        error={error}
        inputRef={inputRef}
        onKeyDown={onKeyDown}
        InputProps={InputProps}
        // multiline={rows}
        rows={4}
      />
    </Box>
  );
};

export default CustomTextBox;
